<div class="d-flex w-100">
  <div
    *ngFor="let fieldName of this.filterFields"
    class="input-group m-1"
  >
    <div class="input-group-prepend">
      <button
        class="btn btn-outline-secondary pl-1 pr-1"
        type="button"
        [attr.disabled]="(disabledFor(fieldName) | async) ? true : null"
        (click)="nudgeFilter(fieldName, -1)"
      >
        <fa-icon [icon]="['fas', 'arrow-left']">&#8592;</fa-icon>
      </button>
    </div>
    <!-- simpler than the default template, to make rendering long lists faster -->
    <ng-template #filterResult let-result="result">{{result}}</ng-template>
    <input
      #filterInputs
      [attr.data-field-name]="fieldName"
      type="text"
      class="form-control"
      [placeholder]="translate(fieldName)"
      [editable]="false"
      [ngbTypeahead]="searchFor(fieldName)"
      [resultTemplate]="filterResult"
      [attr.disabled]="(disabledFor(fieldName) | async) ? true : null"
      [value]="this.filter$s.get(fieldName).value | async"
      (click)="$event.target.select(); this.filter$s.get(fieldName).click.next('')"
      (focus)="$event.target.select(); this.filter$s.get(fieldName).focus.next('')"
      (selectItem)="this.filter$s.get(fieldName).value.next($event.item)"
      (blur)="$event.target.value = this.filter$s.get(fieldName).value.getValue()"
    />
    <div class="input-group-append">
      <button
        class="btn btn-outline-secondary pl-1 pr-1"
        type="button"
        [attr.disabled]="(disabledFor(fieldName) | async) ? true : null"
        (click)="nudgeFilter(fieldName, 1)"
      >
        <fa-icon [icon]="['fas', 'arrow-right']">&#8594;</fa-icon>
      </button>
    </div>
  </div>
</div>
<div class="d-flex w-100 justify-content-between">
  <qm-date-range-picker (rangeChange)="this.dateRangeSubject.next($event)"></qm-date-range-picker>
  <!-- clipboard popover is on the div because it conflicts with ngbTooltip otherwise -->
  <div
    #clipboardPopover="ngbPopover"
    [ngbPopover]="'Copied to clipboard!' | translate"
    triggers="manual"
    placement="left"
  >
    <button
      *ngIf="clipboardSupported"
      type="button"
      class="btn btn-outline-secondary"
      [attr.disabled]="(this.hasData$ | async) ? null : true"
      (click)="saveToClipboard()"
      [ngbTooltip]="'Copy chart image to clipboard' | translate"
    >
      <fa-icon [icon]="['fas', 'copy']"></fa-icon>
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary"
      [attr.disabled]="(this.hasData$ | async) ? null : true"
      (click)="saveToFile()"
      [ngbTooltip]="'Download chart image' | translate"
    >
      <fa-icon [icon]="['fas', 'download']"></fa-icon>
    </button>
  </div>
</div>
<div class="w-100">
  <qm-chart-js
    type="line"
    [data]="data$ | async"
    [options]="chartOptions$ | async"
  ></qm-chart-js>
</div>
